import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export const apiDownloadAssessmentUserSkillScoresTemplateFile = async ({
  domain = useTenantStore().domain,
  errorConfig = {},
  callbacks = {},
}: GetRequestArgsType = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.assessmentUserSkillScoresTemplateFile({ domain }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
